/// <amd-module name="Repos/FilesHubCommon/FilesHubMenuItems" />
import * as Resources from "Repos/FilesHubCommon/Resources";
import { IMenuItem } from "VSSUI/Menu";

export function getItemCommonMenuItems(
    isFolder: boolean,
    isRoot: boolean,
    hideEditAction: boolean,
    getCommandExecutor: (commandName: string) => () => void
) {
    const menuItems: IMenuItem[] = [];

    if (isFolder) {
        menuItems.push({
            groupKey: "actions",
            iconProps: { iconName: "Add" },
            id: "new",
            subMenuProps: {
                id: "new-submenu",
                items: [
                    {
                        iconProps: { iconName: "Page" },
                        id: "new-file",
                        onActivate: getCommandExecutor("newFile"),
                        text: Resources.File
                    },
                    {
                        iconProps: { iconName: "FabricFolder" },
                        id: "new-folder",
                        onActivate: getCommandExecutor("newFolder"),
                        text: Resources.Folder
                    }
                ]
            },
            text: Resources.New
        });
        menuItems.push({
            groupKey: "actions",
            iconProps: { iconName: "Upload" },
            id: "upload-files",
            onActivate: getCommandExecutor("upload"),
            text: Resources.UploadFiles
        });
    }

    if (!isFolder && !hideEditAction) {
        menuItems.push({
            groupKey: "actions",
            iconProps: { iconName: "Edit" },
            id: "edit",
            onActivate: getCommandExecutor("edit"),
            text: Resources.Edit
        });
    }

    if (!isRoot) {
        menuItems.push({
            groupKey: "actions",
            iconProps: { iconName: "Rename" },
            id: "rename",
            onActivate: getCommandExecutor("rename"),
            text: Resources.Rename
        });
        menuItems.push({
            groupKey: "actions",
            iconProps: { iconName: "Delete" },
            id: "delete",
            onActivate: getCommandExecutor("delete"),
            text: Resources.Delete
        });
    }

    return menuItems;
}
